import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { EmailLoginForm } from './EmailLoginForm';
import { EmailSignupForm } from './EmailSignupForm';
import { PhoneLoginForm } from './PhoneLoginForm';
import { Box, Paper, Tabs, Tab, Container, useTheme, useMediaQuery, CircularProgress } from '@mui/material';
import { Email, Phone, PersonAdd } from '@mui/icons-material';
import { useAuth } from './AuthContext';
export const AuthScreen = ({ onSuccess, onError, initialMode = 'email-login' }) => {
    const [mode, setMode] = useState(initialMode);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const { currentUser, loading } = useAuth();
    // Watch for successful authentication
    useEffect(() => {
        if (currentUser && !loading && onSuccess) {
            onSuccess();
        }
    }, [currentUser, loading, onSuccess]);
    const handleTabChange = (_, newValue) => {
        setMode(newValue);
    };
    return (_jsx(Container, { maxWidth: "sm", children: _jsxs(Paper, { elevation: 3, sx: {
                mt: 4,
                p: 2,
                borderRadius: 2,
                position: 'relative'
            }, children: [loading && (_jsx(Box, { sx: {
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: 'rgba(255, 255, 255, 0.7)',
                        zIndex: 10,
                        borderRadius: 2
                    }, children: _jsx(CircularProgress, {}) })), _jsxs(Tabs, { value: mode, onChange: handleTabChange, variant: "fullWidth", sx: {
                        mb: 3,
                        '& .MuiTab-root': {
                            minWidth: isMobile ? 70 : 160
                        }
                    }, children: [_jsx(Tab, { value: "email-login", label: isMobile ? "Email" : "Email Login", icon: _jsx(Email, {}), iconPosition: isMobile ? "top" : "start" }), _jsx(Tab, { value: "phone-login", label: isMobile ? "Phone" : "Phone Login", icon: _jsx(Phone, {}), iconPosition: isMobile ? "top" : "start" }), _jsx(Tab, { value: "email-signup", label: isMobile ? "Sign Up" : "Sign Up", icon: _jsx(PersonAdd, {}), iconPosition: isMobile ? "top" : "start" })] }), _jsxs(Box, { sx: { p: 1 }, children: [mode === 'email-login' && (_jsx(EmailLoginForm, { onError: onError })), mode === 'email-signup' && (_jsx(EmailSignupForm, { onError: onError })), mode === 'phone-login' && (_jsx(PhoneLoginForm, { onError: onError }))] })] }) }));
};
